export default __webpack_public_path__ + "static/media/leh3.59bea732.jpg";